import {ValueObject} from '@s-ui/domain'

import {RequestSearchValueObject} from './RequestSearchValueObject.js'

export class UrlSearchValueObject extends ValueObject {
  #params
  #path
  #query

  constructor({params, path, query}) {
    super()
    this.#params = params
    this.#path = path
    this.#query = query
  }

  static createFromSearch({config, listingSectionId, search}) {
    const {PATHS, PATHS_BY_LISTING_SECTION_ID} = config.get('paths')
    const {DEFAULT_FILTER_SEARCH_VALUE, FILTER_NAMES} = config.get('searchFilters')
    const {LISTING_SECTION_IDS_BY_CATEGORIES_AND_OFFER_TYPES} = config.get('listingSections')
    const {LISTING_SECTION_IDS} = config.get('COMMON')

    const currentListingSectionId =
      listingSectionId ||
      LISTING_SECTION_IDS_BY_CATEGORIES_AND_OFFER_TYPES[search[FILTER_NAMES.CATEGORY_1]]?.[search.offerTypeId] ||
      LISTING_SECTION_IDS.ALL_VEHICLES

    const requestSearchValueObject = RequestSearchValueObject.createQueryParams({
      config,
      listingSectionId: currentListingSectionId,
      search: {...search, [FILTER_NAMES.CATEGORY_1]: DEFAULT_FILTER_SEARCH_VALUE}
    })

    return new UrlSearchValueObject({
      params: requestSearchValueObject.queryParams,
      path: PATHS_BY_LISTING_SECTION_ID[currentListingSectionId] || PATHS.ADS_LIST_SEARCH,
      query: requestSearchValueObject.queryString
    })
  }

  static createFromStockSearch({config, dealerSlug, listingSectionId, search}) {
    const {STOCK_PATHS_BY_LISTING_SECTION_ID} = config.get('paths')

    const requestSearchValueObject = RequestSearchValueObject.createQueryParams({
      config,
      listingSectionId,
      search
    })

    return new UrlSearchValueObject({
      params: requestSearchValueObject.queryParams,
      path: `${STOCK_PATHS_BY_LISTING_SECTION_ID[listingSectionId]}${dealerSlug}/`,
      query: requestSearchValueObject.queryString
    })
  }

  get params() {
    return this.#params
  }

  get path() {
    return this.#path
  }

  get query() {
    return this.#query
  }

  get url() {
    return `${this.#path}${this.#query}`
  }

  get value() {
    return {
      params: this.#params,
      path: this.#path,
      query: this.#query
    }
  }
}
